<script>

    import Moment from 'moment'

    import GraphicsService from '../$services/graphics.service'
    import NumeralMethods from '../$methods/numeral.methods'

    export let dateStart = null
    export let dateEnd = null

    let users = []

    $: periodLabel = dateStart && dateEnd
        ? `${Moment(dateStart).locale('es').format('D MMM YYYY')} - ${Moment(dateEnd).locale('es').format('D MMM YYYY')}`
        : ''

    $: load(dateStart, dateEnd)

    async function load(start, end) {
        if (!start || !end) return

        const res = await GraphicsService.getChargesUsers({
            dateStart: start.toISOString(),
            dateEnd: end.toISOString(),
        })

        users = res?.data?.users ?? []
    }

</script>

<div class="card">
    <div class="header">
        <div>
            <h3 class="title">Usuarios con más cargos</h3>
            {#if periodLabel}
                <p class="period">{ periodLabel }</p>
            {/if}
        </div>
    </div>

    <table>
        <thead>
            <tr>
                <th class="rank">#</th>
                <th>Usuario</th>
                <th class="num">Cargos</th>
                <th class="num">Monto</th>
            </tr>
        </thead>
        <tbody>
            {#each users as user, i}
                <tr>
                    <td class="rank">{ i + 1 }</td>
                    <td class="client">{ user.user }</td>
                    <td class="num">{ user.charges }</td>
                    <td class="num">{ NumeralMethods.cash(user.amount) }</td>
                </tr>
            {:else}
                <tr>
                    <td colspan="4" class="empty">Sin datos en el periodo</td>
                </tr>
            {/each}
        </tbody>
    </table>
</div>

<style>
    .card {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
        padding: 1.35rem 1.5rem;
        height: 100%;
    }

    .header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 1rem;
        margin-bottom: 1.15rem;
    }

    .title {
        font-size: 1.05rem;
        font-weight: 700;
        color: #1a1a1a;
        margin: 0 0 0.25rem;
        line-height: 1.2;
    }

    .period {
        font-size: 0.85rem;
        color: #9e9e9e;
        margin: 0;
        text-transform: capitalize;
    }

    table {
        width: 100%;
        border-collapse: collapse;
    }

    th {
        font-size: 0.8rem;
        font-weight: 500;
        color: #9e9e9e;
        text-align: left;
        padding: 0.55rem 0.5rem;
        border-bottom: 1px solid #f0f0f0;
    }

    td {
        font-size: 0.9rem;
        color: #1a1a1a;
        padding: 0.85rem 0.5rem;
        border-bottom: 1px solid #f5f5f5;
        vertical-align: middle;
    }

    tr:last-child td {
        border-bottom: none;
    }

    .num {
        text-align: right;
        white-space: nowrap;
    }

    .rank {
        color: #9e9e9e;
        width: 2rem;
    }

    .client {
        font-weight: 600;
    }

    .empty {
        text-align: center;
        color: #9e9e9e;
        padding: 2rem 0.5rem;
    }
</style>
